/* eslint-disable react-hooks/exhaustive-deps */
// TOPO "Editorial fixo" (modelo_topo = 6): cabeçalho FIXO no topo, fundo SÓLIDO = cor
// primária do tema (cor1), com estética editorial. Comportamento hide-on-scroll: some ao
// rolar p/ baixo (translateY(-100%)), reaparece ao rolar p/ cima. 3 zonas: logo à esquerda
// (respeita site.tamanho_logo), menu ao centro/direita com sublinhado animado que cresce da
// esquerda no hover/ativo, ícones de redes sociais à direita. No mobile vira hambúrguer que
// reusa o DrawerComponent (renderizado pela variante de busca, via setActiveDrawer).
// TUDO VARIÁVEL: nenhum texto/cor hardcoded — menu = itens do tenant, cores = site.corN com
// contraste adaptativo (ensureReadableTextColor/isColorLight), logo/redes = dados do tenant.
// O default export é um ErrorBoundary com fallback pro Topo padrão (mesmo padrão do TopoCentral):
// qualquer erro de dados/render degrada pro cabeçalho de sempre — nunca deixa a página sem topo.
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaPhoneAlt, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';
import { anuncieWhatsAppDoSite } from '../../../utils/anuncieWhatsApp';
import { ensureReadableTextColor, getContrastRatio, isColorLight } from '../../../utils/FunctionsGlobals';
import { trackMetaEvent } from '../../../utils/metaPixel';
import { resolveSiteWhatsAppUrl } from '../../../utils/site2524WhatsApp';
import { buildContatoTopoUrl, menuLateralSempreNoTopo, mostraContatoNoTopo, mostraTelefonesNoLugarDoMenu, topoEnxuto } from '../../../utils/topoContato';
import { appendCodsiteQuery } from '../../../utils/url';
import { useAuth, useSiteRegiao } from '../../context/Info';
import MenuLateralAgrupado, { linksPrincipais, paginaAnuncie } from '../../drawer/MenuLateralAgrupado';
import { temSeletorIdiomas } from '../../../utils/idiomaMoedaSite';
import { IdiomaNavItem } from '../idiomas/menu';
import Topo from '../topo/Topo';
import styles from './TopoEditorial.module.css';

interface ITopoEditorial {
    site: any;
    setActiveDrawer: any;
    fallback?: React.ReactNode;
}

type NavItem = { label: string; href: string; external?: boolean };

// cs2657 Rafael Carara (25/09/2026): logo alinhada à esquerda com o texto do banner
// ("Imóveis de alto padrão..."). A barra passa a usar a mesma grade do hero Editorial
// (40px de respiro, 1440px de conteúdo). O tamanho 2× vem do recorte da arte (a margem
// transparente ocupava 41% da largura) — não há regra de tamanho aqui.
// Allowlist por codsite: nos demais sites o topo segue igual.
const TOPO_EDITORIAL_LOGO_ALINHADA_HERO = new Set<number>([2657]);

const TopoEditorialInner: React.FC<ITopoEditorial> = ({ site: siteProp, setActiveDrawer }) => {
    // MULTI-REGIÃO: contatos/dados trocados pelos da região ativa quando houver.
    const site = useSiteRegiao(siteProp);
    const { allDataHome } = useAuth();
    const router = useRouter();
    const codsite = Array.isArray(router.query?.codsite) ? router.query?.codsite[0] : router.query?.codsite;

    // codsite só resolve no cliente (appendCodsiteQuery usa o host) — anexa só após montar
    // p/ o href do SSR bater com a 1ª render do cliente (evita hydration mismatch).
    const [isMounted, setIsMounted] = useState(false);
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);
    useEffect(() => {
        setIsMounted(true);
        const onScroll = () => {
            const y = window.scrollY || 0;
            const prev = lastScrollY.current;
            // some ao rolar p/ baixo depois de passar o próprio header; reaparece ao subir.
            if (y > 140 && y > prev) setHidden(true);
            else setHidden(false);
            lastScrollY.current = y;
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    const withCodsite = (path: string) => (isMounted ? appendCodsiteQuery(path, codsite) : path);

    // TOPO ENXUTO (cs2606, utils/topoContato): barra com Comprar · Alugar · Empreendimentos, botão
    // "Anuncie seu imóvel", busca e ☰ — o ☰ abre o MenuLateralAgrupado (direita, em grupos) em vez
    // do menu lateral comum. Páginas do CRM, Blog e redes saem da barra e vão para o menu.
    const enxuto = topoEnxuto(site);
    const [menuAberto, setMenuAberto] = useState(false);

    // fundo SÓLIDO = cor primária do tema (cor1) + texto/ícones com contraste adaptativo real.
    const corHeader = site?.cor1 || '#141414';
    const corHeaderText = ensureReadableTextColor(isColorLight(corHeader) ? site?.cor13 : site?.cor11, corHeader) || '#ffffff';
    // sublinhado/accent = cor2; se não contrastar no header, cai pra própria cor do texto.
    const corAccent = ensureReadableTextColor(site?.cor2, corHeader, 1.8, corHeaderText, corHeaderText) || corHeaderText;
    const logoHeight = Number(site?.tamanho_logo) > 1 ? Math.min(Number(site?.tamanho_logo), 72) : 60;

    // menu horizontal: mesmos itens do menu do site (transações + menus disponíveis + blog).
    const navItems: NavItem[] = enxuto ? linksPrincipais(site) : [];
    if (!enxuto) (site?.transacoes || []).forEach((t: string) => {
        if (!t) return;
        const low = String(t).toLowerCase();
        const label = low === 'venda' ? 'Comprar' : low === 'aluguel' ? 'Alugar' : low === 'temporada' ? 'Temporada' : t;
        navItems.push({ label, href: `/imoveis/${low}/-/-/-/-` });
    });
    if (!enxuto) (allDataHome?.menus || [])
        .filter((m: any) => m?.Disponivel && m?.titulo)
        .slice(0, 6)
        .forEach((m: any) => {
            navItems.push({ label: m.titulo, href: m?.link ? m.link : `/menu/${m.titulo}`, external: Boolean(m?.link && !String(m.link).startsWith('/')) });
        });
    if (!enxuto && allDataHome?.blogs?.[0]?.id) navItems.push({ label: 'Blog', href: '/blog' });

    const socials = enxuto ? [] : [
        { href: site?.Dados?.instagram, Icon: FaInstagram, rede: 'Instagram' },
        { href: site?.Dados?.facebook, Icon: FaFacebook, rede: 'Facebook' },
        { href: site?.Dados?.youtube, Icon: FaYoutube, rede: 'Youtube' },
        { href: site?.Dados?.tiktok, Icon: FaTiktok, rede: 'Tiktok' },
        { href: site?.Dados?.Linkedin, Icon: FaLinkedin, rede: 'Linkedin' },
    ].filter((s) => s.href);

    // CONTATO NA BARRA (#1447, cs2631): esta variante nasceu só com logo + menu + redes; o
    // Clássico sempre mostrou o telefone. Gate por tenant (utils/topoContato) — os outros 16
    // sites com este topo continuam exatamente como estão. Telefone e flag de WhatsApp vêm do
    // cadastro do tenant (Dados.tel1/tel1_whats), já regionalizados pelo useSiteRegiao acima.
    const contatoTelefone = mostraContatoNoTopo(site) ? (site?.Dados?.tel1 ?? '') : '';
    const contatoEhWhats = !!site?.Dados?.tel1_whats;
    const contatoHref = buildContatoTopoUrl({
        telefone: contatoTelefone,
        ehWhatsapp: contatoEhWhats,
        texto: site?.texto_botao_whats
            ? String(site.texto_botao_whats)
            : `Olá, estou visitando o site da ${site?.Dados?.empresa ?? ''}, gostaria de um atendimento personalizado. Pode me ajudar?`,
        resolveWhats: (fallback) => resolveSiteWhatsAppUrl(site, fallback),
    });

    // TELEFONES NO LUGAR DO MENU (cs2639, utils/topoContato): sem "Comprar/Alugar/Blog"; no lugar,
    // tel1 e tel2 do cadastro (ícone de WhatsApp em quem tem a flag), números e redes no azul da
    // marca (cor2) e o ☰ visível também no computador. Fora da lista nada disso existe.
    const telefonesNoMenu = mostraTelefonesNoLugarDoMenu(site);
    const corMarcaTopo = site?.cor2 || '#344175';
    const telefonesTopo = telefonesNoMenu
        ? [
              { tel: site?.Dados?.tel1, whats: !!site?.Dados?.tel1_whats },
              { tel: site?.Dados?.tel2, whats: !!site?.Dados?.tel2_whats },
          ]
              .filter((p) => String(p.tel ?? '').replace(/\D/g, ''))
              .map((p) => ({
                  ...p,
                  href: buildContatoTopoUrl({
                      telefone: p.tel,
                      ehWhatsapp: p.whats,
                      texto: site?.texto_botao_whats
                          ? String(site.texto_botao_whats)
                          : `Olá, estou visitando o site da ${site?.Dados?.empresa ?? ''}, gostaria de um atendimento personalizado. Pode me ajudar?`,
                      resolveWhats: (fallback) => resolveSiteWhatsAppUrl(site, fallback),
                  }),
              }))
        : [];

    // botão "Anuncie seu imóvel" do topo enxuto: a página do CRM; sem ela, o WhatsApp próprio do
    // anuncie (utils/anuncieWhatsApp); sem nenhum dos dois, o botão não aparece. Fundo = cor10 (a do
    // menu lateral) se destacar da barra; senão a cor do texto da barra.
    const anuncie = enxuto
        ? paginaAnuncie(allDataHome?.menus || []) ||
          (anuncieWhatsAppDoSite(site)
              ? { label: 'Anuncie seu imóvel', href: `https://api.whatsapp.com/send?phone=${anuncieWhatsAppDoSite(site)}&text=${encodeURIComponent('Olá, gostaria de anunciar um imóvel.')}`, externo: true, novaAba: true }
              : null)
        : null;
    const corCta = site?.cor10 && getContrastRatio(site.cor10, corHeader) >= 3 ? site.cor10 : corHeaderText;
    const corCtaTexto = ensureReadableTextColor(isColorLight(corCta) ? site?.cor11 : site?.cor13, corCta) || '#ffffff';
    const idMenuEnxuto = 'menu-lateral-topo';

    // busca do topo enxuto: na home desce até a busca do banner (âncora #myLink, a mesma do "Busca
    // avançada" do topo2); sem ela, segue o link para a listagem com todos os filtros.
    const irParaBusca = (e: React.MouseEvent) => {
        trackMetaEvent(site, 'ViewContent', { content_name: 'Busca do cabeçalho', content_category: 'property_search' });
        const alvo = typeof document !== 'undefined' ? document.getElementById('myLink') : null;
        if (!alvo) return;
        e.preventDefault();
        alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const logoSrc = site?.url_logo ? `${site?.url_logo}?v=${site?.contador_marca || 0}` : '';
    const logoAlinhadaHero = TOPO_EDITORIAL_LOGO_ALINHADA_HERO.has(Number(site?.id));

    return (
        // BUILDER: âncora estável do bloco "topo" (cobre esta variante em qualquer página).
        <div className={styles.wrapper} data-builder-section="topo">
            {/* espaçador: mantém o fluxo (header é fixed/fora de fluxo) — evita layout shift. */}
            <div className={styles.spacer} aria-hidden="true" />

            <header
                className={`${styles.header} ${hidden ? styles.headerHidden : ''}`}
                style={{ background: corHeader }}
            >
                <div
                    className={`${styles.inner}${telefonesNoMenu ? ` ${styles.innerTelefones}` : ''}${
                        logoAlinhadaHero ? ` ${styles.innerAlinhadaHero}` : ''
                    }${enxuto ? ` ${styles.innerEnxuto}` : ''}`}
                >
                    {/* logo esquerda */}
                    <Link
                        prefetch={false}
                        href={withCodsite('/')}
                        onClick={() => trackMetaEvent(site, 'ViewContent', { content_name: 'Logo da imobiliária', content_category: 'header_navigation' })}
                        className={styles.logoLink}
                        title={`Imobiliária ${site?.Dados?.empresa || ''}`}
                    >
                        {logoSrc ? (
                            <Image
                                src={logoSrc}
                                alt={`Imobiliária ${site?.Dados?.empresa || ''}`}
                                title={`Imobiliária ${site?.Dados?.empresa || ''}`}
                                className={styles.logo}
                                height={logoHeight}
                                width={240}
                                priority
                                fetchPriority="high"
                                unoptimized
                            />
                        ) : (
                            <span className={styles.logoText} style={{ color: corHeaderText }}>
                                {site?.Dados?.empresa || ''}
                            </span>
                        )}
                    </Link>

                    {/* menu centro/direita (desktop) — no cs2639 dá lugar aos telefones */}
                    {telefonesNoMenu ? (
                        <div className={styles.telefones}>
                            {telefonesTopo.map((p, idx) => (
                                <a
                                    key={idx}
                                    href={p.href}
                                    target={p.whats ? '_blank' : undefined}
                                    rel={p.whats ? 'noopener noreferrer' : undefined}
                                    className={styles.telefone}
                                    style={{ color: corMarcaTopo }}
                                    title={p.whats ? 'Falar no WhatsApp da imobiliária' : 'Ligar para a imobiliária'}
                                    aria-label={`${p.whats ? 'WhatsApp' : 'Telefone'} ${p.tel}`}
                                    onClick={() => {
                                        trackMetaEvent(site, 'Contact', {
                                            content_name: 'Contato do cabeçalho',
                                            contact_method: p.whats ? 'whatsapp' : 'phone',
                                            content_category: 'header',
                                        });
                                    }}
                                >
                                    {p.whats ? <FaWhatsapp aria-hidden="true" /> : <FaPhoneAlt aria-hidden="true" />}
                                    <span className={styles.telefoneNumero}>{p.tel}</span>
                                </a>
                            ))}
                        </div>
                    ) : (
                    <nav className={styles.nav} aria-label="Menu principal">
                        {navItems.map((item, idx) =>
                            item.external ? (
                                <a
                                    key={idx}
                                    href={item.href}
                                    className={styles.navLink}
                                    style={{ color: corHeaderText, ['--nav-underline' as any]: corAccent }}
                                    rel="noopener noreferrer"
                                >
                                    {item.label}
                                </a>
                            ) : (
                                <Link
                                    prefetch={false}
                                    key={idx}
                                    href={withCodsite(item.href)}
                                    className={styles.navLink}
                                    style={{ color: corHeaderText, ['--nav-underline' as any]: corAccent }}
                                >
                                    {item.label}
                                </Link>
                            )
                        )}
                        {/* 22/10: idioma no computador, no fim do menu — só quando o ☰ some no computador (com ele
                            sempre visível, o item fica ao lado do ☰, abaixo) */}
                        {temSeletorIdiomas(site) && !(menuLateralSempreNoTopo(site) || enxuto) ? (
                            <IdiomaNavItem
                                ocultarAte={900}
                                classeBotao={styles.navLink}
                                estilo={{ color: corHeaderText, ['--nav-underline' as any]: corAccent }}
                            />
                        ) : null}
                    </nav>
                    )}

                    {/* redes sociais (desktop) */}
                    {socials.length > 0 ? (
                        <div className={styles.socials}>
                            {socials.map((s, idx) => (
                                <a
                                    key={idx}
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={`Navegar para o ${s.rede} da imobiliária`}
                                    className={styles.social}
                                    style={{ color: telefonesNoMenu ? corMarcaTopo : corHeaderText }}
                                >
                                    <s.Icon aria-hidden="true" />
                                </a>
                            ))}
                        </div>
                    ) : null}

                    {/* contato (#1447): ícone + número, à DIREITA das redes. No celular fica só
                        o ícone — o número inteiro não cabe ao lado do hambúrguer. */}
                    {contatoHref ? (
                        <a
                            href={contatoHref}
                            target={contatoEhWhats ? '_blank' : undefined}
                            rel={contatoEhWhats ? 'noopener noreferrer' : undefined}
                            className={styles.contato}
                            style={{ color: corHeaderText }}
                            title={contatoEhWhats ? 'Falar no WhatsApp da imobiliária' : 'Ligar para a imobiliária'}
                            onClick={() => {
                                trackMetaEvent(site, 'Contact', {
                                    content_name: 'Contato do cabeçalho',
                                    contact_method: contatoEhWhats ? 'whatsapp' : 'phone',
                                    content_category: 'header',
                                });
                            }}
                        >
                            {contatoEhWhats ? <FaWhatsapp aria-hidden="true" /> : <FaPhoneAlt aria-hidden="true" />}
                            <span className={styles.contatoNumero}>{contatoTelefone}</span>
                        </a>
                    ) : null}

                    {/* topo enxuto (cs2606): botão "Anuncie seu imóvel" + busca, à esquerda do ☰ */}
                    {anuncie ? (
                        anuncie.externo ? (
                            <a
                                href={anuncie.href}
                                target={anuncie.novaAba ? '_blank' : undefined}
                                rel={anuncie.novaAba ? 'noopener noreferrer' : undefined}
                                className={styles.cta}
                                style={{ background: corCta, color: corCtaTexto }}
                            >
                                Anuncie seu imóvel
                            </a>
                        ) : (
                            <Link prefetch={false} href={withCodsite(anuncie.href)} className={styles.cta} style={{ background: corCta, color: corCtaTexto }}>
                                Anuncie seu imóvel
                            </Link>
                        )
                    ) : null}
                    {enxuto ? (
                        <Link
                            prefetch={false}
                            href={withCodsite('/imoveis/venda/-/-/-/-')}
                            className={styles.iconeTopo}
                            aria-label="Buscar imóveis"
                            title="Buscar imóveis"
                            onClick={irParaBusca}
                            style={{ color: corHeaderText }}
                        >
                            <FiSearch aria-hidden="true" />
                        </Link>
                    ) : null}

                    {/* 22/10 (rodada 2): idioma NA BARRA, ao lado do ☰ (a linha da gaveta/menu lateral saiu) — no
                        celular só a bandeira; no computador só quando o ☰ fica sempre à vista (sem o item do menu) */}
                    {temSeletorIdiomas(site) ? (
                        <IdiomaNavItem
                            compactoAte={900}
                            ocultarAcima={telefonesNoMenu || menuLateralSempreNoTopo(site) || enxuto ? undefined : 900}
                            estilo={{ color: corHeaderText }}
                        />
                    ) : null}

                    {/* hambúrguer (mobile; no cs2639, cs2656 e cs2606 também no computador) */}
                    <button
                        type="button"
                        className={telefonesNoMenu || menuLateralSempreNoTopo(site) || enxuto ? `${styles.hamburger} ${styles.sempreVisivel}` : styles.hamburger}
                        aria-label="Abrir menu"
                        aria-haspopup={enxuto ? 'dialog' : undefined}
                        aria-expanded={enxuto ? menuAberto : undefined}
                        aria-controls={enxuto ? idMenuEnxuto : undefined}
                        onClick={() => (enxuto ? setMenuAberto(true) : setActiveDrawer(true))}
                        style={{ color: corHeaderText }}
                    >
                        <span className={styles.hamburgerBar} style={{ background: corHeaderText }} />
                        <span className={styles.hamburgerBar} style={{ background: corHeaderText }} />
                        <span className={styles.hamburgerBar} style={{ background: corHeaderText }} />
                    </button>
                </div>
            </header>

            {enxuto && isMounted ? (
                <MenuLateralAgrupado
                    site={site}
                    aberto={menuAberto}
                    onFechar={() => setMenuAberto(false)}
                    institucional={enxuto.institucional}
                    idPainel={idMenuEnxuto}
                />
            ) : null}
        </div>
    );
};

// ErrorBoundary → fallback pro Topo padrão (mesmo padrão do TopoCentral).
class TopoEditorial extends React.Component<ITopoEditorial, { hasError: boolean }> {
    constructor(props: ITopoEditorial) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch() {
        // silencioso: o topo degrada pro padrão sem quebrar a página.
    }
    render() {
        const { site, setActiveDrawer, fallback } = this.props;
        const defaultTopo = fallback ?? <Topo site={site} setActiveDrawer={setActiveDrawer} />;
        if (this.state.hasError || !site) return defaultTopo;
        return <TopoEditorialInner {...this.props} />;
    }
}

export default TopoEditorial;
